import {
  PaymentPeriodEnum,
  PlanEnum,
  SubscriptionSourceEnum,
  SubscriptionStatusEnum,
  SubscriptionUserInfoSchema,
} from "@billingnow/zod-schema";
import { apiClient } from "./client";

export type SubscriptionUserInfo = SubscriptionUserInfoSchema;

export type Entitlement = {
  tier: PlanEnum;
  status: SubscriptionStatusEnum | null;
  source: SubscriptionSourceEnum | null;
  hasAccess: boolean;
  billingPeriod: "Monthly" | "Yearly" | null;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
};

export const getEntitlement = async (): Promise<Entitlement> => {
  const response = await apiClient.get<Entitlement>("/api/me/entitlements");
  return response.data;
};

export const getSubscription = async (): Promise<SubscriptionUserInfo> => {
  const response = await apiClient.get<SubscriptionUserInfo>("/api/subscription/plan");
  return response.data;
};

/** Start the card-less web trial (no checkout). 409s once the trial was used. */
export const startTrial = async (): Promise<SubscriptionUserInfo["subscription"]> => {
  const response = await apiClient.post<{ subscription: SubscriptionUserInfo["subscription"] }>(
    "/api/subscription/start-trial",
  );
  return response.data.subscription;
};

export const upgradeToPro = async (
  planType: PlanEnum,
  paymentPeriod: PaymentPeriodEnum,
): Promise<{ isUpdating: boolean; url?: string }> => {
  const response = await apiClient.post<{ isUpdating: boolean; url?: string }>(
    `/api/subscription/upgrade/${planType}/${paymentPeriod}`,
  );
  return response.data;
};

export const cancelPlan = async (): Promise<{ message: string }> => {
  const response = await apiClient.post<{ message: string }>("/api/subscription/cancel-plan");
  return response.data;
};
